module.exports = __webpack_public_path__ + "img/wooddouble.0193d714.png";